import { inject } from "@angular/core";
import { InteractionType, IPublicClientApplication, PublicClientApplication, Configuration } from "@azure/msal-browser";
import { HostConfigService } from "@core/services/host-config.service";
import { environment } from "@env/environment";

export function msalInstanceFactory(): IPublicClientApplication {
  const hostConfigService = inject(HostConfigService);
  const configuracionDominio = hostConfigService.getCurrentMsalConfig();

  if (!configuracionDominio) {
    throw new Error(
      `Configuración de MSAL no encontrada para el hostname: ${hostConfigService.getHostname()}.`
    );
  }

  const msalConfig: Configuration = {
    auth: {
      clientId: configuracionDominio.clientId,
      authority: `https://${environment.ciamSubdomain}.ciamlogin.com/${environment.tenantId}`,
      redirectUri: configuracionDominio.redirectUri,
      postLogoutRedirectUri: configuracionDominio.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true
    },

    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: number, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
        },
        logLevel: 1
      }
    }
  };

  return new PublicClientApplication(msalConfig);
}

export function msalGuardConfigFactory(): object {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        'user.read',
        `${environment.scopeApi}`
      ],
      prompt: 'login'
    }
  };
}

export function msalInterceptorConfigFactory(): object {
  const hostConfigService = inject(HostConfigService);
  const baseServiceUrl = hostConfigService.getCurrentBaseServiceUrl();

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ['https://graph.microsoft.com/v1.0/me', ['user.read']],
      [baseServiceUrl, [`${environment.scopeApi}`]]
    ])
  };
}
